var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwimmingPool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34961 15L3.94961 14.1C7.84961 12.8 12.2496 13.7 15.3496 16.5C18.4496 19.3 22.7496 20.2 26.7496 18.9L29.3496 18",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3496 9C24.5587 9 26.3496 7.20914 26.3496 5C26.3496 2.79086 24.5587 1 22.3496 1C20.1405 1 18.3496 2.79086 18.3496 5C18.3496 7.20914 20.1405 9 22.3496 9Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.35 18L18.35 17C20.05 15.3 20.05 12.6 18.35 11L10.85 3.49995C9.45 2.09995 7.25 2.09995 5.85 3.49995L1.45 7.89995C0.85 8.49995 0.85 9.49995 1.45 10.1C1.95 10.6 2.75 10.7 3.45 10.3L8.35 6.99995L11.35 9.99995L7.85 13.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmingPool);
export default __webpack_public_path__ + "static/media/swimmingPool.56257a3b33603d54b758dbe772f41cdd.svg";
export { ForwardRef as ReactComponent };